import { render, staticRenderFns } from "./EpgContainer.vue?vue&type=template&id=32cb9988&scoped=true"
import script from "./EpgContainer.vue?vue&type=script&lang=js"
export * from "./EpgContainer.vue?vue&type=script&lang=js"
import style0 from "./EpgContainer.vue?vue&type=style&index=0&id=32cb9988&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "32cb9988",
  null
  
)

export default component.exports